import { render, staticRenderFns } from "./MonthlyProfit.vue?vue&type=template&id=1cb1134b&"
import script from "./MonthlyProfit.vue?vue&type=script&lang=js&"
export * from "./MonthlyProfit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports